/**
 * How the workspace page writes a time and a person: one place for the Overview and the Activity tab.
 */

/** "19:20" for an event time, or with `day: true` "27 Oct, 19:20"; '' when it is not a time. */
export function eventTime(at, { day = false } = {}) {
  const date = new Date(at);
  if (!at || Number.isNaN(date.getTime())) { return ''; }
  return day
    ? date.toLocaleString('en-GB', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' })
    : date.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
}

const same = (a, b) => Boolean(a) && Boolean(b) && String(a).toLowerCase() === String(b).toLowerCase();

/**
 * A member's name as the page can know it: the members list carries only `email` (and `sub` once known), so the name
 * comes from the workspace's owners (`owners: [{ sub, email, name }]`) or a project owner with the same sub or email;
 * else the email. "You" for the person looking.
 */
export function memberName(member, workspace, userSub) {
  if (userSub && member?.sub && member.sub === userSub) { return 'You'; }
  const people = [...(workspace?.owners || []), workspace?.owner, ...(workspace?.projects || []).map((project) => project.owner)].filter(Boolean);
  const match = people.find((person) => person.name && ((member?.sub && person.sub === member.sub) || same(person.email, member?.email)));
  return match?.name || member?.email || 'Someone';
}

/** The word for a workspace role. */
export const roleLabel = (role) => ({ owner: 'Owner', editor: 'Editor' }[role] || 'Viewer');
